import logo from '../../Images/logo-short.png';
import React from 'react';
import {Navbar, Nav, NavDropdown} from 'react-bootstrap';
import CustomTranslation from "./CustomTranslation";
import UserAction from "../../Actions/UserAction";
import TranslationAction from "../../Actions/TranslationAction";
import {generatePath} from "react-router-dom";
import Config from "../../Config.json";
import LicenseAction from "../../Actions/LicenseAction";
import LanguageAction from '../../Actions/LanguageAction';

class CustomHeader extends React.Component {

    //constructor
    constructor(props) {
        super(props);

        //init state
        this.state = {
            user: null
        };
    }

    //on mount
    componentDidMount = () => {
        this.updateElements();
    }

    //change language
    onChangeLanguage = async (languageId, languageCode, languageName) => {
        let formData = {
            uiLanguage: `/api/languages/${languageId}`
        };
        //make call
        await UserAction.editUser(this.state.user.id, formData);
        //set language in local translation system
        await TranslationAction.setLanguage(languageCode, languageName);
        //refresh
        window.location.reload();
    }

    //log out
    onLogOut = async () => {
        //do logout action
        await UserAction.logoutSubmit();
        //go to login screen
        window.location.href = generatePath('/login');
    }

    //get a display label from a language object
    getLanguageLabel = (language, preferredCode) => {
        if (!language) return '';

        //name can be a translated object like { nl: 'Nederlands', en: 'Dutch' }
        if (language.name && typeof language.name === 'object') {
            return language.name[preferredCode]
                || language.name['en']
                || Object.values(language.name).find(v => typeof v === 'string')
                || '';
        }

        if (typeof language.name === 'string') return language.name;

        return language.languageCode || '';
    }

    //find the current language from the list, with fallbacks
    resolveCurrentLanguage = (languages, userLanguageCode) => {
        if (languages.length === 0) {
            return { languageCode: 'nl', name: { nl: 'Nederlands', en: 'Dutch' } };
        }

        return languages.find(l => l.languageCode === userLanguageCode)
            || languages.find(l => l.languageCode === 'nl')
            || languages[0];
    }

    //build language dropdown options
    buildLanguageOptions = (languages, currentLanguage) => {
        return languages.map(language => {
            let isCurrent = language.languageCode === currentLanguage.languageCode;
            let label = this.getLanguageLabel(language, currentLanguage.languageCode);

            return (
                <NavDropdown.Item
                    key={language.languageCode}
                    disabled={isCurrent}
                    onClick={isCurrent ? undefined : (e) => {
                        e.preventDefault();
                        this.onChangeLanguage(language.id, language.languageCode, label);
                    }}
                >
                    {isCurrent && <i className={'las la-check'} />}
                    {label}
                </NavDropdown.Item>
            );
        });
    }

    //check if user has reporting rights
    checkReportingRights = async () => {
        let licenses = await LicenseAction.getLicenses(true);
        for (let [, license] of Object.entries(licenses)) {
            if (license.company) {
                let right = await UserAction.getUserRightByCompanyId(license.company.id);
                if (right && (right.adminRights || right.managementRights)) return true;
            }
        }
        return false;
    }

    refreshLanguages = async () => {
        let languages = await LanguageAction.getAllUILanguages() || [];
        let currentLanguage = this.state.currentLanguage;
        let languageOptions = this.buildLanguageOptions(languages, currentLanguage);
        this.setState({ languageOptions });
    }

    updateElements = async () => {
        let user = await UserAction.getCurrentUser();

        //get available UI languages
        let languages = await LanguageAction.getAllUILanguages() || [];

        // If user has no uiLanguage, set it to Dutch (nl) and reload user
        let userLanguageCode = (user && user.uiLanguage && user.uiLanguage.languageCode)
            ? user.uiLanguage.languageCode
            : null;

        if (!userLanguageCode && languages.length > 0) {
            // Find Dutch language object
            const dutchLang = languages.find(l => l.languageCode === 'nl') || languages[0];
            if (dutchLang) {
                // Update user to set uiLanguage to Dutch
                await UserAction.editUser(user.id, { uiLanguage: `/api/languages/${dutchLang.id}` });
                // Reload user
                user = await UserAction.getCurrentUser();
                userLanguageCode = dutchLang.languageCode;
            }
        } else if (!userLanguageCode) {
            // fallback if no languages loaded
            userLanguageCode = 'nl';
        }

        //find current language
        let currentLanguage = this.resolveCurrentLanguage(languages, userLanguageCode);

        //convert name to string for the dropdown title
        currentLanguage = {
            ...currentLanguage,
            code: currentLanguage.languageCode,
            name: this.getLanguageLabel(currentLanguage, currentLanguage.languageCode)
        };

        //build dropdown options and check reporting rights
        let languageOptions = this.buildLanguageOptions(languages, currentLanguage);
        let reporting = await this.checkReportingRights();

        this.setState({ user, currentLanguage, languageOptions, reporting });
    }

    render = () => {

        let userName = null;
        if (this.state.user) {
            //name to display
            userName = this.state.user.email;
            if (this.state.user.firstName && this.state.user.lastName) {
                userName = this.state.user.firstName + ' ' + this.state.user.lastName;
            }
        }

        //return
        return (
            <div style={{flexDirection: 'column', display: 'flex', alignItems: 'center', zIndex: 10}} className={'shadow'}>
                <div style={{maxWidth: this.props.extraWide ? 1500 : 1000, width: '100%'}}>
                    <Navbar bg="white" expand="lg">
                        <Navbar.Brand href="/">
                            <img alt="CSC logo" src={logo} height="30"/>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                        <Navbar.Collapse id="basic-navbar-nav">
                            {this.state.currentLanguage &&
                                <Nav className="mr-auto">
                                    <NavDropdown
                                        title={this.state.currentLanguage.name}
                                        id={'language-dropdown'}
                                        onToggle={(isOpen) => { if (isOpen) this.refreshLanguages(); }}
                                    >
                                        {this.state.languageOptions}
                                    </NavDropdown>
                                </Nav>
                            }
                            {userName &&
                                <Nav>
                                    <NavDropdown id={'user-dropdown'}
                                                 alignRight
                                                 title={
                                                     <span style={{display: 'inline-block'}}>

                                                            {this.state.user.picture ?
                                                                <span
                                                                    style={{
                                                                        display: 'inline-block',
                                                                        backgroundImage: 'url("' + this.state.user.picture.resizedPath + '")',
                                                                        height: '2rem',
                                                                        width: '2em',
                                                                        minWidth: '2rem',
                                                                        minHeight: '2rem',
                                                                        backgroundSize: 'cover',
                                                                        backgroundRepeat: 'no-repeat',
                                                                        backgroundPosition: 'center',
                                                                        borderRadius: '50%',
                                                                        position: 'absolute',
                                                                        top: '0.20rem',
                                                                        left: '-0.2rem'
                                                                    }}
                                                                />
                                                                :
                                                                <span className={'text-primary'} style={{display: 'inline-block', position: 'absolute', top: '0.20rem', left: '0rem'}}>
                                                                    <i style={{fontSize: '2rem'}} className={'las la-user-circle'} />
                                                                </span>
                                                            }
                                                            <span style={{display: 'inline-block', marginLeft: '2rem'}}>{userName}</span>
                                                     </span>
                                                }
                                            >
                                        {this.state.reporting ?
                                            <React.Fragment>
                                                <NavDropdown.Item
                                                    href={generatePath('/reporting/actions')}
                                                >
                                                    <i className={'las la-flag text-primary'}/>&nbsp;<CustomTranslation
                                                    value={'KEY.Reporting - Actions'}/>
                                                </NavDropdown.Item>
                                                <NavDropdown.Item
                                                    href={generatePath('/reporting')}
                                                >
                                                    <i className={'las la-flag text-primary'}/>&nbsp;<CustomTranslation
                                                    value={'KEY.Reporting - Tools'}/>
                                                </NavDropdown.Item>
                                                <NavDropdown.Divider/>
                                            </React.Fragment> : null
                                        }
                                        <NavDropdown.Item
                                            href={generatePath('/preferences')}
                                        >
                                            <i className={'las la-cog text-primary'}/>&nbsp;<CustomTranslation value={'KEY.Preferences'}/>
                                        </NavDropdown.Item>
                                        <NavDropdown.Item onClick={(event) => {
                                            event.preventDefault();
                                            window.open('https://www.cscapp.eu/tarieven/', '_blank');
                                        }}>
                                            <i className={'las la-sync text-primary'}/>&nbsp;<CustomTranslation value={'KEY.Subscriptions'}/>
                                        </NavDropdown.Item>
                                        <NavDropdown.Divider/>
                                        <NavDropdown.Item onClick={(event) => {
                                            event.preventDefault();
                                            window.open('https://www.cscapp.eu/privacy-policy/', '_blank');
                                        }}>
                                            <i className={'las la-shield-alt text-primary'}/>&nbsp;<CustomTranslation value={'KEY.Privacy policy'}/>
                                        </NavDropdown.Item>
                                        <NavDropdown.Item onClick={(event) => {
                                            event.preventDefault();
                                            window.open('https://www.cscapp.eu/privacypolicystores', '_blank');
                                        }}>
                                            <i className={'las la-file-contract text-primary'}/>&nbsp;<CustomTranslation value={'KEY.Terms of use'}/>
                                        </NavDropdown.Item>
                                        <NavDropdown.Divider/>
                                        <NavDropdown.Item
                                            onClick={(event) => {
                                                event.preventDefault();
                                                this.onLogOut();
                                            }}
                                        >
                                            <i className={'las la-sign-out-alt text-primary'}/>&nbsp;<CustomTranslation value={'KEY.Logout'}/>
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                </Nav>
                            }
                        </Navbar.Collapse>
                    </Navbar>
                </div>
            </div>
        );
    }
}

//export
export default CustomHeader;